import { DialogModule } from '@angular/cdk/dialog';
import { Component, Inject, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogClose } from '@angular/material/dialog';
import { FormInputNumberComponent } from "../forms/form-input-number.component";
import { Fulfillment } from '../../../../globalTypes/fulfillment.types';
import { httpsCallable, HttpsCallableResult } from 'firebase/functions';
import { Functions } from '@angular/fire/functions';
import { GetShippingTransactionInfoData } from '../../../../globalTypes/thirdPartyTypes';
import { ButtonComponent } from "../layout/element/button.component";
import { MatSnackBar } from '@angular/material/snack-bar';
import { CurrencyPipe } from '@angular/common';
import { LimiterDirective } from '../../directive/limiter';
import { onCallFunctions } from '../../../../globalTypes/backend.api.types';

export interface StartShippingData {
  fulfillment: Fulfillment
  rateId?: string
  rateCost?: number
  shippingTransactionId?: string
  trackingNumber?: string
  trackingUrl?: string
  messageToBuyer?: string
}

@Component({
  selector: 'msh-start-shipping',
  imports: [FormsModule, LimiterDirective, MatDialogClose, CurrencyPipe, FormInputNumberComponent, ButtonComponent],
  template: `
  <div class=" min-w-[80vw] md:min-w-[600px]">
    @for(errorMessage of errorMessages; track errorMessage;){
      <div class=" mx-8 mt-3 text-red-500">{{errorMessage}}</div>
    }
    <div class=" p-8">
      @if(data.fulfillment.shippingTransactionId){
        <div class="flex flex-wrap gap-3">
          <msh-button [disabled]="!labelUrl" (onClick)="printShippingLabel()" cta="Print Shipping Label"></msh-button>
        </div>
        <div class="flex justify-between gap-6 mt-3">
          <div>Tracking Number: <a [href]="trackingUrlProvider" class=" text-orange-400 hover:underline">{{trackingNumber}}</a></div>
          <div>Shipping Cost: {{data.rateCost | currency}}</div>
        </div>
        <div class="flex flex-wrap gap-6">
          <div class="lil-action" (click)="copyTrackingUrl()">copy tracking url</div>
        </div>
      } @else {
        <msh-form-input-number
          [price]="data.rateCost"
          [placeholder]="'Actual shipping cost'"
          [limiterValue]="2000"
          (onPriceChange)="shippingCostChange($event)"
        ></msh-form-input-number>
        <div>
          <input
            type="text"
            placeholder="Tracking Number"
            [(ngModel)]="data.trackingNumber"
            [limiter]="1000"
            name="trackingNumber"
            required
          />
        </div>
        <div>
          <input
            type="text"
            placeholder="Tracking Url"
            [(ngModel)]="data.trackingUrl"
            [limiter]="2000"
            name="trackingUrl"
            required
          />
        </div>
      }
      @if(data.fulfillment.statusId === "fulfilling"){
        <div>
          <textarea [(ngModel)]="data.messageToBuyer"
            name="message"
            [limiter]="1000"
            class="border"
            rows="7"
            placeholder="Message (optional)"
          ></textarea>
        </div>
      }
    </div>
  <div class="bg-copy/10 flex justify-between py-4 px-6 gap-3">
      <button mat-flat-button [mat-dialog-close]="false">Close</button>
      @if(data.fulfillment.statusId === "fulfilling"){
        <button [mat-dialog-close]="data">Mark As Shipped</button>
      }
  </div>
   </div>
  `,
  styles: ``
})
export class StartShippingDialogComponent implements OnInit {
  trackingNumber?: string;
  trackingUrlProvider?: string;
  labelUrl?: string;
  errorMessages: string[] = [];

  constructor(
    private functions: Functions,
    private snackBar: MatSnackBar,
    public dialogRef: MatDialogRef<StartShippingDialogComponent>, 
    @Inject(MAT_DIALOG_DATA) public data: StartShippingData
  ){
    console.log({data: this.data})
  }

  async ngOnInit(): Promise<void> {
    const callable = httpsCallable<{transactionId: string}, GetShippingTransactionInfoData>(this.functions, onCallFunctions.getShippingInformation);
    if(this.data.fulfillment.shippingTransactionId){
      const shippingRef: HttpsCallableResult<GetShippingTransactionInfoData> = await callable({transactionId: this.data.fulfillment.shippingTransactionId})
      if(shippingRef.data.messages.length){
        shippingRef.data.messages.forEach(message=>{
          console.error({message: message.text})
        })
        this.errorMessages = shippingRef.data.messages.filter(m=>!!m.text).map(m=>m.text || "") || []
      }
      const { labelUrl, trackingNumber, trackingUrlProvider } = shippingRef.data;
      console.log({shippingRef: shippingRef.data})
      this.labelUrl = labelUrl;
      this.trackingNumber = trackingNumber;
      this.trackingUrlProvider = trackingUrlProvider;
    }
  }

  printShippingLabel(){
    window.open(this.labelUrl, '_blank')
  }

  viewTrackingSite(){
    window.open(this.trackingUrlProvider, '_blank');
  }

  copyTrackingUrl(){
    navigator.clipboard.writeText(this.trackingUrlProvider || "").then(()=>{
      this.snackBar.open("Tracking URL copied!", undefined, {duration: 600})
    }).catch(error => {
      this.snackBar.open("Something went wrong while copying to your clipboard", undefined, {duration: 1600})
    })
  }

  shippingCostChange(ev: number){
    this.data.rateCost = ev
  }
}
